<template>
  <div>
    <el-button
      style="margin-bottom: 20px"
      type="primary"
      @click="add(null)"
      v-if="hasAuth('sys:advertising:add')"
      >添加弹窗
    </el-button>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column
        align="center"
        label="名称"
        prop="name"
      ></el-table-column>
      <el-table-column align="center" label="类型描述">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 0" type="primary"> 商品详情 </el-tag>
          <el-tag v-if="scope.row.type == 1" type="primary"> 商品分类 </el-tag>
          <el-tag v-if="scope.row.type == 2" type="success"> 直播 </el-tag>
          <el-tag v-if="scope.row.type == 3" type="success"> 公众号 </el-tag>
          <el-tag v-if="scope.row.type == 4" type="success"> 视频号 </el-tag>
          <el-tag v-if="scope.row.type == 5" type="info"> 隐私政策 </el-tag>
          <el-tag v-if="scope.row.type == 6" type="info"> 用户协议 </el-tag>
          <el-tag v-if="scope.row.type == 7" type="success"> 企业微信 </el-tag>
          <el-tag v-if="scope.row.type == 8" type="success"> 企业客服 </el-tag>
          <el-tag v-if="scope.row.type == 9" type="primary"> 优惠券 </el-tag>
          <el-tag v-if="scope.row.type == 10" type="primary"> 热销活动 </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="图片">
        <template slot-scope="scope">
          <img :src="scope.row.cover" alt="" height="50px" width="50px" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 1" type="success">已启用</el-tag>
          <el-tag v-if="scope.row.state == 0" type="danger">未启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" prop="icon">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state == 0 && hasAuth('sys:advertising:edit')"
            plain
            type="primary"
            @click="add(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.state == 0 && hasAuth('sys:advertising:qiyong')"
            plain
            type="primary"
            @click="updState(scope.row)"
          >
            启用</el-button
          >
          <el-button
            v-if="scope.row.state == 1 && hasAuth('sys:advertising:jinyong')"
            plain
            type="danger"
            @click="updState(scope.row)"
          >
            禁用</el-button
          >
          <el-button
            plain
            type="danger"
            v-if="hasAuth('sys:advertising:del')"
            @click="delHandle(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :before-close="handleClose"
      :title="editForm.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="跳转类型" prop="type">
          <el-select
            v-model="editForm.type"
            clearable
            placeholder="选择跳转类型"
            style="width: 100%"
          >
            <el-option :value="0" label="商品详情"></el-option>
            <el-option :value="1" label="商品分类"></el-option>
            <el-option :value="2" label="直播"></el-option>
            <el-option :value="3" label="公众号"></el-option>
            <el-option :value="4" label="视频号"></el-option>
            <el-option :value="5" label="隐私政策"></el-option>
            <el-option :value="6" label="用户协议"></el-option>
            <el-option :value="7" label="企业微信"></el-option>
            <el-option :value="8" label="企业客服"></el-option>
            <el-option :value="9" label="优惠券"></el-option>
            <el-option :value="10" label="热销活动"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="弹窗频率小时/次" prop="time">
          <el-input v-model="editForm.time" @input="handleInput"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.type == 2" label="直播Id" prop="liveId">
          <el-input v-model="editForm.liveId"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.type == 3" label="公众号地址">
          <el-input v-model="editForm.officialAccountsId"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.type == 7" label="地址">
          <el-input v-model="editForm.officialAccountsId"></el-input>
        </el-form-item>

        <el-form-item v-if="editForm.type == 4" label="视频号Id" prop="videoId">
          <el-input
            v-model="editForm.videoId"
            placeholder="跳转视频号主页填写（‘sphzy’+视频号原始ID），跳转具体视频号视频填写具体视频ID"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item v-if="editForm.type == 0" label="跳转商品">
          <el-row>
            <el-col :span="18">
              <el-input v-model="editForm.commodityName" disabled></el-input>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                style="height: 40px; width: 100%"
                type="primary"
                @click="SelectGoods()"
                >选择商品
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="editForm.type == 1" label="跳转商品">
          <el-cascader
            ref="cateData"
            v-model="editForm.classify"
            :options="classifyList"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            clearable
            filterable
            placeholder="选择分类"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="弹窗图片" prop="cover">
          <VploadImg
            :limit="1"
            :type="1"
            v-bind:file-list="editForm.cover"
            @submitImg="getImg"
          ></VploadImg>
        </el-form-item>
        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :before-close="handlecrile"
      :visible.sync="goodsVisible"
      append-to-body
      title="选择商品"
      width="80%"
    >
      <div style="padding-bottom: 40px">
        <el-form :inline="true">
          <el-form-item label="商品名" label-width="80px">
            <el-input
              v-model="searchForm.name"
              clearable
              placeholder="商品名"
              @keyup.enter.native="serach"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="serach()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable"
          :data="goodsList"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="商品封面"
            prop="storeGoodsCover"
          >
            <template slot-scope="scope">
              <el-image
                :src="scope.row.cover"
                fit="scale-down"
                style="width: 70px; height: 70px"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="商品名称"
            prop="name"
          ></el-table-column>
          <el-table-column
            align="center"
            label="商品类型"
            prop="firstClassifyName"
          >
            <template slot-scope="scope">
              {{ scope.row.firstClassifyName }}-{{ scope.row.classifyName }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            prop="icon"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                v-if="editForm.commodityId != scope.row.id"
                plain
                type="primary"
                @click="clickgoods(scope.row)"
              >
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="searchForm.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="SizeChange"
          @current-change="CurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgThree";

export default {
  name: "ConfigType",
  components: {
    VploadImg,
  },
  data() {
    return {
      editForm: {
        name: "",
        classify: [],
        classifyId: null,
        commodityId: null,
        commodityName: null,
        cover: [],
        firstClassifyId: null,
        liveId: null,
        officialAccountsId: null,
        time: null,
        type: null,
        videoId: null,
        feedId: null,
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        videoId: [{ required: true, message: "请输入", trigger: "blur" }],
        liveId: [{ required: true, message: "请输入", trigger: "blur" }],
        officialAccountsId: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        classify: [{ required: true, message: "请选择", trigger: "blur" }],
        commodityName: [{ required: true, message: "请选择", trigger: "blur" }],
        type: [{ required: true, message: "请选择", trigger: "blur" }],
        cover: [{ required: true, message: "请上传", trigger: "blur" }],
        time: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      classifyList: [],
      goodsVisible: false,
      searchForm: {
        name: "",
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      goodsList: [],
    };
  },
  created() {
    this.getHomePopList();
  },
  methods: {
    handleInput(value) {
      this.editForm.time =
        value.replace(/[^\d]/g, "").replace(/^0+/g, "") || "";
      if (!this.editForm.time) {
        this.editForm.time = 0;
      }
    },
    add(event) {
      if (event) {
        this.editForm = JSON.parse(JSON.stringify(event));
        this.editForm.cover = [{ url: this.editForm.cover }];
        this.editForm.classifyId = this.editForm.classifyId
          ? "a" + this.editForm.classifyId
          : null;
        this.editForm.classify = this.editForm.classifyId
          ? [this.editForm.firstClassifyId, this.editForm.classifyId]
          : [];
      }
      this.dialogVisible = true;
      this.getflList();
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
    },
    getHomePopList() {
      this.$axios.post("/admin/homePop/getHomePopList", {}).then((res) => {
        this.tableData = res.data;
      });
    },
    SelectGoods() {
      this.goodsVisible = true;
      this.searchForm.pageNo = 1;
      this.serach();
    },
    handlecrile() {
      this.goodsVisible = false;
      this.serach();
    },
    SizeChange(val) {
      this.searchForm.pageSize = val;
      this.serach();
    },
    CurrentChange(val) {
      this.searchForm.pageNo = val;
      this.serach();
    },
    clickgoods(row) {
      this.editForm.commodityId = row.id;
      this.editForm.commodityName = row.name;
      this.goodsVisible = false;
    },
    serach() {
      var obj = JSON.parse(JSON.stringify(this.searchForm));
      delete obj.total;
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", this.searchForm)
        .then((res) => {
          this.goodsList = res.data.records;
          this.searchForm.total = res.data.total;
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            classifyId:
              this.editForm.classify.length > 0
                ? this.editForm.classify[1].substring(1)
                : null,
            commodityId: this.editForm.commodityId,
            cover:
              this.editForm.cover.length > 0 ? this.editForm.cover[0].url : "",
            firstClassifyId:
              this.editForm.classify.length > 0
                ? this.editForm.classify[0]
                : "",
            liveId: this.editForm.liveId,
            name: this.editForm.name,
            officialAccountsId: this.editForm.officialAccountsId,
            time: this.editForm.time,
            type: this.editForm.type,
            videoId: this.editForm.videoId,
          };
          if (this.editForm.id) {
            obj.id = this.editForm.id;
            this.$axios
              .post("/admin/homePop/updateHomePop", obj)
              .then((res) => {
                this.handleClose();
                this.getHomePopList();
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else {
            this.$axios.post("/admin/homePop/addHomePop", obj).then((res) => {
              this.handleClose();
              this.getHomePopList();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
          }
        } else {
          return false;
        }
      });
    },
    getImg(img, add) {
      this.editForm.cover = add == 0 ? [] : [{ url: img }];
    },
    getflList() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          this.classifyList = res.data;
        });
    },
    delHandle(event) {
      var _this = this;
      this.$confirm("此操作将永久删除该弹窗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/admin/homePop/deleteHomePop", {
              id: event,
            })
            .then((res) => {
              _this.getHomePopList();
              _this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
    updState(event) {
      var _this = this;
      this.$confirm(
        event.state == 0
          ? "此操作将启用该弹窗, 是否继续?"
          : "此操作将禁用该弹窗, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          this.$axios
            .post("/admin/homePop/updState", {
              id: event.id,
            })
            .then((res) => {
              _this.getHomePopList();
              _this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
